import { Fragment, useRef } from "react";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import InvoiceDateSection from "./InvoiceDateSection";
import InvoiceHead from "./InvoiceHead";
import InvoiceTableHead from "./InvoiceTableHead";

const InvoiceFiveContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  return (
    <Fragment>
      <Container>
        <Row>
          <Col sm="12" className="invoice-2">
            <div ref={contentRef}>
              <Card>
                <CardBody>
                  <Table borderless>
                    <tbody>
                      <InvoiceHead />
                      <InvoiceDateSection />
                      <tr>
                        <td>
                          <InvoiceTableHead />
                        </td>
                      </tr>
                      <tr style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <td>
                          <Image src={dynamicImage(`email-template/invoice-3/sign.png`)} alt="sign" />
                          <span style={{ display: "block", fontSize: "18px", fontWeight: 600 }}>Laurine T. Ebbert</span>
                          <span style={{ display: "block", fontSize: "14px", paddingTop: "5px" }}>( Designer )</span>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
        <InvoiceButtons contentRef={contentRef} />
      </Container>
    </Fragment>
  );
};

export default InvoiceFiveContainer;
